import ShimmerCard from "./ShimmerCard";

const Shimmer = () => {
    return (
      <div data-testid="shimmer" className="flex flex-col sm:flex-row flex-wrap justify-center gap-4 w-11/12 lg:w-5/6 mx-auto mt-8">
        {Array(8).fill("").map((e,index) => <ShimmerCard key={index}/>)}
      </div>
    );
}

export default Shimmer;